define('navigation',["jquery", "underscore", "knockout", "i18n"], function ($, _, ko, i18n) {
    return function(application) {
        var me = this;
        var ignorePopCount = 0;
        var homepage = i18n.routes.placesRoot;
        var animateBack = false;

        var hasRoutePrefix = function (url, routeRoot) {
            var path = (url || "").split(/[?#]/, 1)[0].replace(/\/+$/, "");
            var root = (routeRoot || "").split(/[?#]/, 1)[0].replace(/\/+$/, "");
            return path === root || path.indexOf(root + "/") === 0;
        };
        
        me.page = ko.observable();
        me.stack = ko.observableArray();
        me.navigate = function(target, replace, modalParameters, onLeave, withoutTransition) {
            if(typeof target == "undefined")
            {
                target = homepage;
            }

            var targetUrl = typeof target === "string" ? target : target.url;
            var currentPrefix = i18n.routes.placesRoot.split("/").slice(0, 3).join("/");
            if (!window.cordova && targetUrl &&
                (hasRoutePrefix(targetUrl, "/locale/switch") ||
                 (/^\/(cs|en|sk)\//.test(targetUrl) && !hasRoutePrefix(targetUrl, currentPrefix)))) {
                window.location.assign(targetUrl);
                return;
            }
            
            var isModal = false;
            if(typeof modalParameters === "boolean") isModal = modalParameters;
            else if(typeof modalParameters === "object")
            {
                isModal = true;
            }
            
            if(application.isWebsite && !isModal)
            {
                window.location = target;
                return;
            }
            
            var currentPage = me.page();
            
            if(currentPage)
            {
                currentPage.scrollY = $("html,body").scrollTop();
            }
            
            
            var pageItem = {};

            if(typeof target === "string")
            {
                pageItem.url = target;
            } else {
                pageItem = target;
            }
            
            pageItem.isModal = isModal;

            if(me.stack().length > 0) {
                if(me.stack()[me.stack().length - 1].isModal && !isModal)
                    replace = true;
            }
            
            if(!isModal) {
                me.page(pageItem);
            }
            
            var historyUrl = window.cordova || pageItem.url.indexOf("/") != 0 ? "#" + pageItem.url : pageItem.url;
            if(replace)
            {
                console.log("navigation.navigate.replace", historyUrl);
                history.replaceState({applicationNavigation: !isModal, modalNavigation: isModal, page: pageItem}, "", historyUrl);

                pageItem.onLeave = onLeave;
                
                var previous = me.stack.pop();
                me.stack.push(pageItem);
                
                if(previous.onLeave)
                    previous.onLeave(previous);
                
            } else {
                console.log("navigation.navigate.push", historyUrl);
                history.pushState({applicationNavigation: !isModal, modalNavigation: isModal, page: pageItem}, "", historyUrl);

                pageItem.onLeave = onLeave;
                
                me.stack.push(pageItem);
            }
            
            if(!isModal) {
                if (window.plugins && window.plugins.nativepagetransitions && !withoutTransition && !pageItem.isSectionRoot)
                    window.plugins.nativepagetransitions.slide({direction: "left"});
            }
        };
        
        me.restorePrevious = function (popState) {
            var pageItemBeforePop = me.stack.pop();
            
            if(pageItemBeforePop && typeof pageItemBeforePop.onLeave == "function")
                pageItemBeforePop.onLeave(pageItemBeforePop, popState);
            
            if(pageItemBeforePop && pageItemBeforePop.isModal)
                return;
            
            var pageReturnTo = me.stack().length > 0 ? me.stack()[me.stack().length - 1] : null;
            
            if(pageReturnTo == null || popState == null || popState.page == null || pageReturnTo.url != popState.page.url) {
                if(application.isApp) {
                    console.error("Error in restorePrevious navigation");
                } else {
                    return;
                }
            }
            
            console.log("pageItemBeforePop", JSON.stringify(pageItemBeforePop));
            
            if(!pageItemBeforePop || !pageItemBeforePop.isModal) {
                if(popState && popState.applicationNavigation)
                {
                    console.log("Updating page after back with applicationNavigation");
                    me.page(pageReturnTo ? pageReturnTo : popState.page);
                } else if(!popState) {
                    console.log("Updating page after back without popstate");
                    me.page({url: window.cordova ? window.location.hash.substr(1) : window.location.pathname || homepage, scrollY: pageReturnTo ? pageReturnTo.scrollY : 0})
                }
            }
            
            if(!pageItemBeforePop.isModal && animateBack) {
                if (window.plugins && window.plugins.nativepagetransitions)
                    window.plugins.nativepagetransitions.slide({direction: "right"});
                    animateBack = false;
            }
        };
        
        me.canNavigateBack = ko.computed(function () {
            if(me.page() && me.page().isSectionRoot)
                return false;
            
            return application.enableSPA ? me.stack().length > 1 : me.stack().length > 0;
        });
        
        me.back = function ()
        {
            animateBack = true;
            console.log("navigation.back");
            if(me.canNavigateBack())
                history.back();
        };
        
        var sectionForUrl = function(url) {
            if(!url)
                return null;

            if(hasRoutePrefix(url, i18n.routes.placesRoot))
                return "venues";

            if(hasRoutePrefix(url, i18n.routes.vegboardRoot))
                return "vegboard";

            if(hasRoutePrefix(url, i18n.routes.feedRoot))
                return "feed";

            if(hasRoutePrefix(url, i18n.routes.accountRoot) || hasRoutePrefix(url, "/account"))
                return "account";            

            return null;            
        };
        
        me.section = ko.computed(function () {
            var page = me.page();
            
            if(page == null)
                return null;

            return sectionForUrl(page.url);
        });
        
        me.sectionNavigation = function (url) {
            me.navigate({url: url, isSectionRoot: true});
            
            // if(me.stack().length > 1)
            // {
            //     var previousPage = me.stack()[me.stack().length - 2];
            //    
            //     if(sectionForUrl(previousPage.url) == sectionForUrl(url)) me.back();
            //     else me.navigate({url: url, isSectionRoot: true});
            // } else {
            //     me.navigate({url: url, isSectionRoot: true});
            // }
        };
        
        me.reload = function () {
            if(application.isApp) me.navigate(me.page(), true);
            else window.location.reload();
        }

        console.log("navigation.addEventListener");
        window.addEventListener('popstate', function(event){
            console.log("navigation.popstate", event);
            me.restorePrevious(event.state);
        });        
        
        if(application.enableSPA)
        {
            $("body").on("click", "a", function (event) {
                if($(this).attr("href") === "#")
                {
                    event.preventDefault();
                }
                else if ($(this).attr("href").indexOf("/") == 0) {
                    event.preventDefault();
                    
                    me.navigate({ url: $(this).attr("href") });
                } else if($(this).attr("href").indexOf("#") < 0) {
                    if(window.navigator.standalone) {
                        event.preventDefault();
                        window.location = $(this).attr("href");
                    } else if(window.cordova) {
                        event.preventDefault();
                        
                        var externalBrowser = $(this).data("vz-linkbrowser") === "external";
                        
                        if(!externalBrowser && window.cordova.platformId == "ios" && window.SafariViewController) window.SafariViewController.show({url: $(this).attr("href")});
                        else if(!externalBrowser && window.cordova.platformId == "android") cordova.InAppBrowser.open($(this).attr("href"), "_blank", "location=yes");
                        else cordova.InAppBrowser.open($(this).attr("href"), "_system");
                        //else window.location = $(this).attr("href"); 
                    }
                }
            });            
        }
    };
});

